namespace $ { export class $mol_app_todomvc_demo extends $mol_app_todomvc {

} }

